var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.197,
    height: 55.092,
    viewBox: "0 0 55.197 55.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_129100",
    "data-name": "Group 129100",
    transform: "translate(1.956 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129097",
    "data-name": "Group 129097",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107797",
    "data-name": "Path 107797",
    d: "M125.022,129.525l-10.25,18.493,10.178-2.294,3.584,10.035,8.816-17.2",
    transform: "translate(-114.772 -104.18)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107798",
    "data-name": "Path 107798",
    d: "M132.613,129.525l10.25,18.493-10.178-2.294L129.1,155.759l-8.816-17.2",
    transform: "translate(-91.577 -104.18)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_60188",
    "data-name": "Ellipse 60188",
    cx: 16.996,
    cy: 16.996,
    rx: 16.996,
    ry: 16.996,
    transform: "translate(8.447 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_111360",
    "data-name": "Path 111360",
    d: "M-20966.34-14300.363l5.514,4.8,9.078-10.176",
    transform: "translate(20984.686 14317.143)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.3f1285df715606ba47468a24de550691.svg";
export { ForwardRef as ReactComponent };